import { render, staticRenderFns } from "./edit-banner.vue?vue&type=template&id=f5b0a652&scoped=true&"
import script from "./edit-banner.vue?vue&type=script&lang=js&"
export * from "./edit-banner.vue?vue&type=script&lang=js&"
import style0 from "./edit-banner.vue?vue&type=style&index=0&id=f5b0a652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b0a652",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
